// extracted by mini-css-extract-plugin
export default {"txtActive":"AdminShop_txtActive__x4DsY","txtInactive":"AdminShop_txtInactive__VEyvf"};